import { Calendar } from "lucide-react";

import { PRESETS } from "../lib/periodos";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";


/**
 * Período + regime. Stateless: recebe valores e setters.
 *
 * O seletor de regime fica aqui, e não escondido em configurações, porque muda
 * o significado do relatório inteiro: competência conta pelo vencimento (o mês
 * a que o gasto pertence) e caixa pelo pagamento (quando o dinheiro saiu). Ler
 * um sem saber qual é leva a conclusão errada.
 */
export default function FiltroPeriodo({
  preset, setPreset, inicio, setInicio, fim, setFim, regime, setRegime,
}) {
  return (
    <div className="rounded-2xl border bg-card p-4 space-y-4">
      <div className="flex flex-wrap items-center gap-2">
        <div className="flex items-center gap-2 mr-1">
          <Calendar className="w-4 h-4 text-muted-foreground" />
          <span className="text-sm font-medium text-muted-foreground">Período:</span>
        </div>
        {PRESETS.map((p) => (
          <Button
            key={p.key}
            size="sm"
            variant={preset === p.key ? "default" : "outline"}
            onClick={() => setPreset(p.key)}
          >
            {p.label}
          </Button>
        ))}
      </div>

      {preset === "custom" && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-3 border-t">
          <div>
            <label className="text-xs font-medium mb-1 block text-muted-foreground">De</label>
            <Input type="date" value={inicio} onChange={(e) => setInicio(e.target.value)} />
          </div>
          <div>
            <label className="text-xs font-medium mb-1 block text-muted-foreground">Até</label>
            <Input type="date" value={fim} onChange={(e) => setFim(e.target.value)} />
          </div>
        </div>
      )}

      <div className="flex flex-wrap items-center gap-2 pt-3 border-t">
        <span className="text-sm font-medium text-muted-foreground mr-1">Regime:</span>
        <Button
          size="sm"
          variant={regime === "competencia" ? "default" : "outline"}
          onClick={() => setRegime("competencia")}
        >
          Competência
        </Button>
        <Button
          size="sm"
          variant={regime === "caixa" ? "default" : "outline"}
          onClick={() => setRegime("caixa")}
        >
          Caixa
        </Button>
        <p className="text-[11px] text-muted-foreground w-full sm:w-auto sm:ml-2">
          {regime === "competencia"
            ? "Despesas contam pelo vencimento — o mês a que pertencem."
            : "Só despesas já pagas, pela data do pagamento."}
        </p>
      </div>
    </div>
  );
}
